import { Component, Input, OnInit } from '@angular/core';

import { AppVoiceMessagesSelectSearch } from 'src/app/core/types/app-voice-message-select-search.type';
import { VoiceMessagesService } from './../../../core/api/services/voice-messages.service';
import { BaseSelectSearch } from './base/base-select-search.component';
import { BaseSelectSearchModule } from './base/base-select.search.module';

@Component({
    selector: 'app-voice-message-select-search',
    templateUrl: './base/base-select-search-template.html',
    imports: [BaseSelectSearchModule]
})
export class VoiceMessagesSelectSearchComponent
  extends BaseSelectSearch
  implements OnInit
{
  @Input('type') type: AppVoiceMessagesSelectSearch = 'voicesList';

  constructor(protected currentService: VoiceMessagesService) {
    super();
  }

  initConfig() {
    super.initConfig();
    if (!this.label) this.label = 'common.voiceMessage';
  }

  getItemsApi() {
    switch (this.type) {
      // voices list
      case 'voicesList':
        this.currentService
          .voiceMessagesGetVoiceMessagesList()
          .pipe(this.basePipeOperators())
          .subscribe(this.baseObserver);
        break;
      case 'voiceMessagesByGroupId':
        if (!this.id) {
          this.loading = false;
          this.initLoading = false;
          return;
        }
        this.currentService
          .voiceMessagesGetVoicesByVoiceMessageGroup({
            VoiceMessageGroupId: this.id,
          })
          .pipe(this.basePipeOperators())
          .subscribe(this.baseObserver);
        break;
    }
  }

  baseObserver = {
    next: (items) => {
      if (items?.data) this.items = items?.data;
      else this.items = items;
      this.setDefaultValue();
      let voiceMessage = this.items.find(
        (voiceMessage) => voiceMessage.id == this.value
      );
      if (voiceMessage) {
        this.itemChange.emit(voiceMessage);
      }
    },
    error: (error) => {
      this.emitError();
    },
    complete: () => {
      this.initLoading = false;
      this.isFetchData = true;
    },
  };
}
